import { LegalLayout, LegalSection } from "@/components/kaje/Legal";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="January 2026" testId="terms-page">
      <LegalSection heading="1. About KAJE">
        <p>
          These terms govern the use of the KAJE website and the provision of services by KAJE,
          an Australian sole trader business operated by Justin Kingaby (ABN 13 907 721 664).
          KAJE provides software development services and delivers consumer-focused mobile
          applications and digital products, including AI-powered features and digital
          subscription services.
        </p>
      </LegalSection>

      <LegalSection heading="2. Services">
        <p>
          Engagements for software development work are agreed in writing between KAJE and the
          client before work commences, including scope, deliverables and fees. This website is
          informational and does not itself constitute an offer capable of acceptance.
        </p>
      </LegalSection>

      <LegalSection heading="3. Digital Products & Subscriptions">
        <p>
          Digital products and subscription services delivered by KAJE are governed by the terms
          presented at the point of purchase within the relevant app or product. Subscription
          billing is recurring and may be cancelled at any time through the account controls in
          the product or by contacting us. Payments are processed securely by Stripe; KAJE does
          not store card details.
        </p>
      </LegalSection>

      <LegalSection heading="4. Refunds">
        <p>
          Refund requests for digital products and subscriptions are assessed in accordance with
          the Australian Consumer Law. Where a product has a major failure, you are entitled to
          the remedies provided by law. To request a refund, contact us via the contact form on
          this website with your purchase details.
        </p>
      </LegalSection>

      <LegalSection heading="5. Intellectual Property">
        <p>
          Unless otherwise agreed in writing, intellectual property in deliverables transfers to
          the client on full payment. KAJE retains the right to reuse general techniques, tools
          and know-how developed during an engagement.
        </p>
      </LegalSection>

      <LegalSection heading="6. Limitation of Liability">
        <p>
          To the extent permitted by law, KAJE's liability is limited to the resupply of the
          services or the cost of resupply. Nothing in these terms excludes rights that cannot be
          excluded under the Australian Consumer Law.
        </p>
      </LegalSection>

      <LegalSection heading="7. Contact">
        <p>
          Questions about these terms: contact Justin Kingaby via the contact form on this
          website. Direct email:{" "}
          <a href="mailto:kajebiz.store@gmail.com" className="text-emerald-700 font-semibold hover:underline" data-testid="terms-email-link">
            kajebiz.store@gmail.com
          </a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
